import gradient1 from '@/assets/img/gradients/hard/gradient-1.jpg'
import gradient2 from '@/assets/img/gradients/hard/gradient-2.jpg'
import gradient3 from '@/assets/img/gradients/hard/gradient-3.jpg'
import gradient4 from '@/assets/img/gradients/hard/gradient-4.jpg'
import gradient5 from '@/assets/img/gradients/hard/gradient-5.jpg'
import gradient6 from '@/assets/img/gradients/hard/gradient-6.jpg'
import gradient7 from '@/assets/img/gradients/hard/gradient-7.jpg'
import gradient8 from '@/assets/img/gradients/hard/gradient-8.jpg'
import gradient9 from '@/assets/img/gradients/hard/gradient-9.jpg'
import gradient10 from '@/assets/img/gradients/hard/gradient-10.jpg'
import gradient11 from '@/assets/img/gradients/hard/gradient-11.jpg'
import gradient12 from '@/assets/img/gradients/hard/gradient-12.jpg'
import gradient13 from '@/assets/img/gradients/hard/gradient-13.jpg'
import gradient14 from '@/assets/img/gradients/hard/gradient-14.jpg'
import gradient15 from '@/assets/img/gradients/hard/gradient-15.jpg'
import gradient16 from '@/assets/img/gradients/hard/gradient-16.jpg'
import gradient17 from '@/assets/img/gradients/hard/gradient-17.jpg'

export const GRADIENTS = {
  gradient1,
  gradient2,
  gradient3,
  gradient4,
  gradient5,
  gradient6,
  gradient7,
  gradient8,
  gradient9,
  gradient10,
  gradient11,
  gradient12,
  gradient13,
  gradient14,
  gradient15,
  gradient16,
  gradient17
} as const